import { Navigate, useLocation, useParams } from "react-router-dom";
import usePageTitle from "@/hooks/usePageTitle";

export default function JobDetailsPage() {
  usePageTitle("/facilities/:facilityId/jobs/job-post/:jobPostId", "Facilities | Jobs | Job Post Details");
  const location = useLocation();
  const { facilityId, jobPostId } = useParams();

  if (!facilityId || !jobPostId) return null;

  return <Navigate to={`${location.pathname}/details`} replace />;
}
